export const RAW_TRANSACTION_ACTIONS = [
  { key: 'purchase_inward', label: 'Purchase Inward', type: 'in' },
  { key: 'production_consumption', label: 'Production Consumption', type: 'out' },
  { key: 'manual_adjustment_plus', label: 'Manual Adjustment +', type: 'in' },
  { key: 'manual_adjustment_minus', label: 'Manual Adjustment -', type: 'out' }
];

export const RAW_TRANSACTION_SYSTEM_ACTIONS = [
  { key: 'order_hold_reserve', label: 'Order Hold Reserve', type: 'hold' },
  { key: 'workflow_auto_consume', label: 'Workflow Auto Consume', type: 'out' },
  { key: 'opening_stock_import', label: 'Opening Stock Import', type: 'in' },
  { key: 'csv_import', label: 'CSV Import', type: 'in' }
];

export const RAW_TRANSACTION_FILTER_ACTIONS = [
  ...RAW_TRANSACTION_ACTIONS,
  ...RAW_TRANSACTION_SYSTEM_ACTIONS
];

export const RAW_TRANSACTION_ACTION_MAP = RAW_TRANSACTION_FILTER_ACTIONS.reduce((acc, item) => {
  acc[item.key] = item;
  return acc;
}, {});

export const getRawTransactionActionLabel = (actionKey, fallbackType = '') => {
  const normalizedAction = String(actionKey || '').trim().toLowerCase();
  if (normalizedAction && RAW_TRANSACTION_ACTION_MAP[normalizedAction]?.label) {
    return RAW_TRANSACTION_ACTION_MAP[normalizedAction].label;
  }

  const normalizedType = String(fallbackType || '').trim().toLowerCase();
  if (normalizedType === 'in') return 'Stock In';
  if (normalizedType === 'out') return 'Stock Out';
  if (normalizedType === 'hold') return 'Hold';
  return '-';
};

const LEGACY_TRANSACTION_FIELD_KEYS = new Set(['color_id', 'yarn_type_id', 'pad_type_id']);

export const isLegacyTransactionField = (field) => {
  const key = String(field?.key || '').trim().toLowerCase();
  const label = String(field?.label || '').trim().toLowerCase();
  if (LEGACY_TRANSACTION_FIELD_KEYS.has(key)) return true;
  if (key === 'color' || label === 'color') return true;
  return false;
};
